export default "__VITE_ASSET__DT1TALNh__"